/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Send(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                data-name='Layer 1'
                height='24'
                viewBox='0 0 40 32'
                width='24'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g fill={iconColor || '#FFFFFF'}>
                    <path d='M39.28,1.11l0,0a1,1,0,0,0-.32-.31l-.08,0a.77.77,0,0,0-.49-.08l-37,4.59A.89.89,0,0,0,1,6.82l12.09,9.46,1.39,14.29a.87.87,0,0,0,.62.75.73.73,0,0,0,.25,0A.88.88,0,0,0,16,31l23.19-29a.89.89,0,0,0,.16-.49A.85.85,0,0,0,39.28,1.11Zm-5,1.82L14,14.78l-10.25-8Zm.55,1.72L16,28.23,14.83,16.31ZM39,1.27Zm0,0Z' />
                </g>
            </svg>
        </SvgIcon>
    );
}